export default {
  isLoveInterest: false,
  relationText: null,
  sameRace: false,
}
